export const LogoMark = ({ className = "h-9 w-auto" }) => (
  <img
    src="/logo-mark.png"
    alt=""
    aria-hidden="true"
    focusable="false"
    className={className}
  />
);

const Logo = ({ light = false, className = "" }) => (
  <img
    src={light ? "/teckube-logo-white.png" : "/teckube-logo.png"}
    alt="TecKube"
    data-testid="teckube-logo"
    className={`h-9 w-auto ${className}`}
  />
);

export default Logo;
